import permissions from './permissions';
import * as actions from './permActions';

/**
 * Checks can user perform certain action
 * @param {User | string} userGroup user or usergroup
 * @param {string} action checked action
 * @param {object} options extra options for the custom rules
 */
export function can(userGroup, action, options = {}) {
  // return early in case no user group or action not known
  if (!userGroup || !permissions[action]) return false;

  let group =
    typeof userGroup === 'object' ? userGroup.acl_group_name : userGroup;

  const perms = permissions[action];
  let isAllowed = false;
  let rulesPassed = true;

  // check permission based on the userGroup and main rules
  if (perms.all) {
    isAllowed = true;
  } else {
    isAllowed = perms.allowed.includes(group);
  }

  // check custom rules
  if (perms.rules.length) {
    for (let rule of perms.rules) {
      rulesPassed = rulesPassed && rule(group, options);
    }
  }

  return isAllowed && rulesPassed;
}

/**
 * Inverted to can
 * @param {User | string} userGroup user or usergroup
 * @param {string} action checked action
 * @param  {...any} args
 */
export function cannot(userGroup, action, ...args) {
  return !can(userGroup, action, ...args);
}

export const permActions = actions;
